import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_system_input = _resolveComponent("ontos-system-input")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_form_panel = _resolveComponent("ontos-form-panel")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, {
    ref: "base",
    "phone-flush": ""
  }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_ontos_form_panel, _mergeProps({ key: 0 }, _ctx.heading, {
            "save-disabled": _ctx.isSaving || !_ctx.hasChanges,
            onSave: _ctx.save
          }), {
            controls: _withCtx(() => [
              _createVNode(_component_ontos_header_action, {
                icon: "mdi-arrow-left",
                label: _ctx.$tt('back'),
                to: _ctx.workspaceDesignRoute(_ctx.params.system, 'info')
              }, null, 8, ["label", "to"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_form, { ref: "form" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ontos_system_input, {
                    ref: "input",
                    "fixed-alias": "",
                    value: _ctx.system,
                    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.system = $event)),
                    systems: _ctx.systems,
                    onShowMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMessage', $event)))
                  }, null, 8, ["value", "systems"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 16, ["save-disabled", "onSave"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}